import { useNavigate } from "react-router-dom";

import { PageHeader } from "@/components/ui/card";
import { useT } from "@/lib/i18n";

import { PropertyForm } from "./PropertyForm";
import { usePropertyContext } from "./PropertyDetailPage";

export function InfoTab() {
  const { property } = usePropertyContext();
  // key — serverdan yangi versiya kelganda forma qayta to'ldiriladi (409 dan keyin "Yangilash")
  return (
    <PropertyForm
      key={`${property.id}:${property.version}`}
      property={property}
      onSaved={() => undefined}
    />
  );
}

export function PropertyCreatePage() {
  const { t } = useT();
  const nav = useNavigate();
  return (
    <>
      <PageHeader title={t("props.new")} />
      <PropertyForm onSaved={(p) => nav(`/properties/${p.id}`, { replace: true })} />
    </>
  );
}
